import { render, staticRenderFns } from "./Thirdlogistics.vue?vue&type=template&id=6372a8ae&"
import script from "./Thirdlogistics.vue?vue&type=script&lang=js&"
export * from "./Thirdlogistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports